<template>
  <div class="paper">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="paperList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || paperList.length > 0">
        <LvItem
          class="lv-list-item"
          v-for="item in paperList"
          :key="item.articleId"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="item.firstAuthor"
          :otherAuthor="item.authorList.split(',').length > 1 ? ',...' : ''"
          :periodicalName="item.type === 1 ? item.meetingThesisName : item.mettingName"
          :periodicalTime="item.type === 1 ? item.meetingThesisTime : item.mettingTime"
          @click.native="toThesisDetail(item.articleId, item.articleType)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>
  
  <script>
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "paper",
  components: {
    LvItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      paperList: [],
    };
  },
  methods: {
    async getUserCollectThesisList(data) {
      this.loading = true;
      const resp = await this.$apis.userServe.getUserCollectThesisList({
        data,
        articleType: 0,
      });
      if (resp.resultCode == 200) {
        this.paperList = resp.data.list;
        this.finished = resp.data.list.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.getUserCollectThesisList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toThesisDetail(id, type) {
      this.$router.push({
        name: "thesisDetail",
        query: {
          id,
          type,
        },
      });
    },
  },
};
</script>
  
<style scoped lang="scss">
.paper {
  width: 100vw;
  min-height: 100vh;
  background-color: #f5f5f5;
  border-radius: 8px;
  .lv-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .lv-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>